import React from "react";

export function PageHeader({ title, subtitle, eyebrow, actions }) {
  return (
    <header className="flex items-start justify-between gap-4 pb-6 mb-6 border-b border-border">
      <div>
        {eyebrow && <div className="overline mb-1" data-testid="page-eyebrow">{eyebrow}</div>}
        <h1
          className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] text-zinc-900"
          data-testid="page-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-muted-foreground mt-2 max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 pt-2">{actions}</div>}
    </header>
  );
}
